module.exports = __webpack_public_path__ + "media/images/web/youtube-684752d898df95d12a40e82a7e4d9465.svg";